import { castArray } from '../../views/utils'
import routes from '../routes'

const appendAuth = ({ auth }) => (child) => {
  if (!auth) return child

  const leadingAuth = castArray(child.auth || auth)
  return { ...child, auth: leadingAuth }
}

const flatten = childRoutes => childRoutes
  .flatMap((route) => {
    const authRoute = [
      {
        name: route.name,
        auth: route.auth ? castArray(route.auth) : undefined,
      },
    ]

    if (!route.children) return authRoute

    return [...authRoute, ...flatten(route.children.map(appendAuth(route)))]
  })

export default Object
  .fromEntries(flatten(routes)
    .filter(route => route.name)
    .map(({ name, auth }) => [name, auth]))
